import { render, staticRenderFns } from "./OrderXsExport.vue?vue&type=template&id=46620116"
import script from "./OrderXsExport.vue?vue&type=script&lang=js"
export * from "./OrderXsExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports